import {
  FormControl,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  IconButton,
} from "@mui/material";
import CustomInput from "../utils/Input";
import { Delete } from "@mui/icons-material";
const width = {
  "Ecosolvent Printing": [
    { value: "5", label: "5'" },
    { value: "10", label: "10'" },
  ],
  "UV Printing": [
    { value: "2", label: "2'" },
    { value: "4", label: "4'" },
    { value: "6", label: "6'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Digital Printing": [
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
    { value: "6", label: "6'" },
  ],
  "Solvent Printing": [
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Plotter Cutting Printing": [
    { value: "2", label: "2'" },
    { value: "3", label: "3'" },
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
  ],
  "Latex Printing": [
    { value: "5", label: "5'" },
    { value: "7", label: "7'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
  ],
};
const brandNames = [
  {
    value: "Ecosolvent Printing",
    brandNames: [
      "Roland",
      "Mimaki",
      "Xuly",
      "Konica",
      "ColorJet",
      "V K",
      "Infinity",
      "Chinese",
      "VuTek",
      "Epson",
      "AuraJet",
      "Any Brand",
    ],
  },
  {
    value: "UV Printing",
    brandNames: [
      "Mimaki",
      "FujiFilm",
      "Docan",
      "Keoundo",
      "Chinese",
      "V K",
      "Infinity",
      "Ricoh",
      "HandTop",
      "Any Brand",
    ],
  },
  {
    value: "Digital Printing",
    brandNames: ["HP", "Canon", "Roland", "Any Brands"],
  },

  {
    value: "Solvent Printing",
    brandNames: [
      "AllWin",
      "UltraJet",
      "ColorJet",
      "Grayscale",
      "Konica 512i",
      "V K",
      "Infinity",
      "Mimaki",
      "VuTek",
      "MehtaFlex",
      "I-Jet",
      "Ink-Jet",
      "Any Brand",
    ],
  },

  {
    value: "Latex Printing",
    brandNames: ["HP", "Any Brand"],
  },
  {
    value: "Plotter Cutting Printing",
    brandNames: [
      "Graphtec",
      "Roland",
      "Saga",
      "Dragon Cut",
      "Chinese",
      "Mimaki",
      "Scy Cut",
      "Any Brand",
    ],
  },
];
const PrintingMachineDetails = ({
  handleInputChangeMachineDetails,
  activeProduct,
  handleDeleteMachineSelection,
  formData,
  operation,
  machine,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 mb-3">
        <FormControl fullWidth size="small">
          <label className="mb-2 text-[var(--para-color)]">{`Type of Printer Head`}</label>
          <Select
            disabled={operation == "view"}
            name={`machineDetails-${activeProduct}-${machine?.type}-machinePrintingSubType`}
            value={
              formData?.products
                ?.find((p) => p.productType === activeProduct)
                ?.machinesNeededForPrinting?.find(
                  (m) => m?.type === machine?.type
                )?.details?.machinePrintingSubType || ""
            }
            onChange={(e) => {
              handleInputChangeMachineDetails(
                activeProduct,
                "machinesNeededForPrinting",
                machine?.type,
                "machinePrintingSubType",
                e.target.value
              );
            }}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <span className="text-[var(--listdown-color)]">
                    {`Select Printing Sub Type:`}
                  </span>
                );
              }
              return selected;
            }}
            inputProps={{
              "aria-label": "Select Machine Printing Sub Type",
            }}
          >
            <MenuItem value="Roll 2 Roll">Roll 2 Roll</MenuItem>
            <MenuItem value="FlatBed">Flat Bed</MenuItem>
            <MenuItem value="Hybrid">Hybrid</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <label className="mb-2 text-[var(--para-color)]">Brand</label>

          {machine.details?.isOtherBrand ? (
            // Show custom input when "Other" selected
            <CustomInput
              placeholder="Enter Brand Name"
              type="text"
              disabled={operation == "view"}
              size="small"
              value={machine.details?.machineBrand || ""}
              onChange={(e) =>
                handleInputChangeMachineDetails(
                  activeProduct,
                  "machinesNeededForPrinting",
                  machine.type,
                  "machineBrand",
                  e.target.value
                )
              }
              className="mt-2"
            />
          ) : (
            <Select
              displayEmpty
              disabled={operation == "view"}
              value={machine.details?.machineBrand || ""}
              onChange={(e) => {
                if (e.target.value === "Other") {
                  handleInputChangeMachineDetails(
                    activeProduct,
                    "machinesNeededForPrinting",
                    machine?.type,
                    "machineBrand",
                    "",
                    {
                      isOtherBrand: true,
                    }
                  );
                } else {
                  handleInputChangeMachineDetails(
                    activeProduct,
                    "machinesNeededForPrinting",
                    machine?.type,
                    "machineBrand",
                    e.target.value,
                    {
                      isOtherBrand: false,
                    }
                  );
                }
              }}
              renderValue={(selected) =>
                !selected ? (
                  <p className="text-[1rem] text-[var(--listdown-color)]">
                    Select Brand
                  </p>
                ) : (
                  <span
                    style={{
                      color: "#000",
                    }}
                  >
                    {selected}
                  </span>
                )
              }
            >
              {brandNames
                ?.find((brandGroup) => brandGroup.value === machine.type)
                ?.brandNames?.map((brand, i) => (
                  <MenuItem value={brand} key={i}>
                    <Radio
                      checked={machine.details?.machineBrand === brand}
                      style={{
                        paddingRight: "8px",
                      }}
                    />
                    {brand}
                  </MenuItem>
                ))}

              <MenuItem value="Other">
                <Radio
                  checked={machine.details?.isOtherBrand}
                  style={{
                    paddingRight: "8px",
                  }}
                />
                Other
              </MenuItem>
            </Select>
          )}
        </FormControl>

        {machine?.type !== "Plotter Cutting Printing" &&
          machine?.type !== "UV Printing" &&
          machine?.type !== "Latex Printing" && (
            <FormControl fullWidth size="small">
              <label className="mb-2 text-[var(--para-color)]">{`Picoliter`}</label>
              <TextField
                select
                disabled={operation == "view"}
                size="small"
                fullWidth
                name={`machineDetails-${activeProduct}-${machine.type}-picoliter`}
                value={
                  formData?.products
                    ?.find((p) => p.productType === activeProduct)
                    ?.machinesNeededForPrinting?.find(
                      (m) => m.type === machine.type
                    )?.details?.picoliter || ""
                }
                onChange={(e) => {
                  handleInputChangeMachineDetails(
                    activeProduct,
                    "machinesNeededForPrinting",
                    machine.type,
                    "picoliter",
                    e.target.value
                  );
                }}
              >
                {[
                  1.2,
                  1.5,
                  2.5,
                  3.5,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  ...Array.from(
                    {
                      length: 25,
                    },
                    (_, i) => i + 11
                  ),
                ]?.map((num) => (
                  <MenuItem key={num} value={num}>
                    {num}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}

        <div className="flex flex-col gap-2">
          <label className=" text-[var(--para-color)]">{`Machine Width (Ft.)`}</label>
          <TextField
            select
            disabled={operation == "view"}
            fullWidth
            size="small"
            name={`machineDetails-${activeProduct}-${machine.type}-maxPrintSize`}
            value={
              formData?.products
                ?.find((p) => p.productType === activeProduct)
                ?.machinesNeededForPrinting?.find(
                  (m) => m.type === machine.type
                )?.details?.maxPrintSize || ""
            }
            onChange={(e) => {
              handleInputChangeMachineDetails(
                activeProduct,
                "machinesNeededForPrinting",
                machine.type,
                "maxPrintSize",
                e.target.value
              );
            }}
            required
          >
            {width[machine.type]?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <FormControl
          fullWidth
          size="small"
          sx={{
            marginBottom: "7px",
          }}
        >
          <label className=" text-[var(--para-color)]">{`Machine Age`}</label>
          <Select
            disabled={operation == "view"}
            name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
            value={
              formData?.products
                ?.find((p) => p.productType === activeProduct)
                ?.machinesNeededForPrinting?.find(
                  (m) => m.type === machine.type
                )?.details?.ageOfMachine || ""
            }
            onChange={(e) => {
              handleInputChangeMachineDetails(
                activeProduct,
                "machinesNeededForPrinting",
                machine.type,
                "ageOfMachine",
                e.target.value
              );
            }}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <span className="text-[var(--listdown-color)]">
                    Select Age
                  </span>
                );
              }
              return selected;
            }}
            inputProps={{
              "aria-label": "Select Machine Age",
            }}
            sx={{
              marginTop: "0.5rem",
            }}
          >
            <MenuItem value="0-4">0 to 4 years</MenuItem>
            <MenuItem value="4+">4 years and above</MenuItem>
          </Select>
        </FormControl>
      </div>
    </>
  );
};

export default PrintingMachineDetails;
